import { render } from "./TotalOrders.vue?vue&type=template&id=4d7a6f9c&ts=true"
import script from "./TotalOrders.vue?vue&type=script&lang=ts"
export * from "./TotalOrders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__